import { axiosInstance } from 'src/util/axios/instance.axios'
import { TeamOrganisationOverviewResponse, TeamOrder, TeamSkillGapMetricsOverview, TeamSortBy } from '../model/my-team'

export async function getTeamSkillGapMetricsBatch(
  levelIds: string[],
): Promise<TeamSkillGapMetricsOverview> {
  const { data } = await axiosInstance.request<TeamSkillGapMetricsOverview>({
    url: '/my-team/team-skill-gap-metrics',
    method: 'POST',
    data: {
      levelIds,
    },
  })

  return data ?? {}
}

export async function getTeamOrganisationOverview(
  skip: number,
  take: number,
  search?: string,
  sortBy?: TeamSortBy,
  order?: TeamOrder,
): Promise<TeamOrganisationOverviewResponse> {
  const { data } = await axiosInstance.request<TeamOrganisationOverviewResponse>({
    url: '/my-team/team-organisation-overview',
    params: {
      skip,
      take,
      ...(search ? { search } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(order ? { order } : {}),
    },
  })

  return data
}
